import { h } from '../index.js';
import * as lib from '../api/case-vouchers.js';
import { fetchLoadable } from '../fetchLoadable.js';
import store from '../store.js';
import * as actionTypes from './actionTypes.js';
export const getMultiple = (query, limit, reload) => {
    const state = store.getState();
    const caseVouchersList = state.caseVouchersList[JSON.stringify(query) ?? ''];
    return fetchLoadable(actionTypes.FETCH_MULTIPLE_CASE_VOUCHERS, lib.getMultiple, {
        query,
        pagination: {
            offset: reload
                ? 0
                : h.hasData(caseVouchersList)
                    ? // @ts-ignore
                        caseVouchersList.data.from
                            ? // @ts-ignore
                                caseVouchersList.data.from
                            : 0
                    : 0,
            limit,
        },
        reload,
    }, true);
};
export const getByCaseId = (caseId) => {
    return fetchLoadable(actionTypes.FETCH_CASE_VOUCHERS_BY_CASE_ID, lib.getByCaseId, {
        caseId,
    }, false);
};
//# sourceMappingURL=actions.js.map